import {initializeFileHandler, removeFile} from './shared/uploader_utils';

let allPurchaseReceipts = []

window.reloadVehicleReceiptUploader = (scope) => {
  const root = scope || document;
  // Target the container where Cocoon inserts nested fields
  const container = root.querySelector('#purchase-receipts-container');

  if (!container) {
    return;
  }

  initializePurchaseReceiptHandler('purchase-receipts', allPurchaseReceipts, root);
  bindPurchaseReceiptRemoveEvent(container, allPurchaseReceipts);

  // Initialize MutationObserver
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      mutation.addedNodes.forEach(function(node) {
        if (node.nodeType === Node.ELEMENT_NODE) {
          const uploadContainer = node.querySelector('.upload-form.file-upload-area');
          const fileField = node.querySelector('input[type="file"]');
          const previewsContainer = root.querySelector('[data-preview=purchase-receipts-preview]');

          if (uploadContainer && fileField && previewsContainer) {
            // Small delay to ensure DOM is ready
            setTimeout(function() {
              initializeFileHandler(uploadContainer, fileField, previewsContainer, allPurchaseReceipts);
            }, 100);
          }
        }
      });
    });
  });

  // Start observing the container for child additions
  observer.observe(container, { childList: true, subtree: true });
}

function initializePurchaseReceiptHandler(attachmentName, selectionList, root) {
  const searchRoot = root || document;
  const container = searchRoot.querySelector(`#${attachmentName}-container`);
  // Initialize handlers for existing permit file fields
  const permitFileForms = container.querySelectorAll('.nested-fields.form-card');

  permitFileForms.forEach(function(form) {
    const uploadContainer = form.querySelector('.upload-form.file-upload-area');
    const fileField = form.querySelector('input[type="file"]');
    const previewsContainer = container.querySelector(`[data-preview=${attachmentName}-preview]`);

    if (uploadContainer && fileField && previewsContainer) {
      initializeFileHandler(uploadContainer, fileField, previewsContainer, selectionList);
    }
  });
}

function bindPurchaseReceiptRemoveEvent(container, selectedList) {
  container.querySelectorAll('.file-preview').forEach(filePreview => {
    filePreview.addEventListener('click', (e) => removeFile(e, selectedList));
  })
}

document.addEventListener('turbolinks:load', function() {
  reloadVehicleReceiptUploader();
});
